import React, { memo, useMemo } from "react";

import { cn } from "utils";
import { isEqual } from "lodash-es";
import ChatCategoryCard from "./ChatCategoryCard";
import { ChatCategoryCardType } from "./type";
import { Cards } from "@features/api/ChatApi";

type CardContainerType = Cards & ChatCategoryCardType;

interface CardContainerProps {
  cards: CardContainerType[];
  createdAt?: string;
  messageId?: string;
  chatId?: string;
  enabled: boolean;
}
const CardContainerOrg: React.FC<CardContainerProps> = ({
  cards,
  createdAt,
  messageId,
  chatId,
  enabled,
}) => {
  const cardsView = useMemo(() => {
    if (!cards || !cards.length) {
      return null;
    }
    return cards.map((cardItem: CardContainerType, index: number) => {
      return (
        <div
          key={index.toString()}
          className={cn("flex pt-3 md:pt-6 flex-col w-full")}
        >
          <ChatCategoryCard
            cardItem={cardItem || {}}
            createdAt={createdAt}
            enabled={enabled}
          />
        </div>
      );
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cards, createdAt, messageId, chatId]);

  return cardsView;
};

// 自定义比较函数
const arePropsEqual = (
  prevProps: CardContainerProps,
  nextProps: CardContainerProps,
) => {
  // Only re-render if these props change
  return isEqual(prevProps, nextProps);
};

const CardContainer = memo(CardContainerOrg, arePropsEqual);
export default CardContainer;
